<template>
  <v-app>
    <!-- Sidebar -->
    <grade-vertical-nav-menu :is-drawer-open.sync="isDrawerOpen" />

    <!-- Top App Bar -->
    <v-app-bar app flat absolute color="transparent">
  <div class="boxed-container w-full">
    <div class="d-flex align-center mx-6" style="position: relative">
      <v-app-bar-nav-icon
        class="d-block d-lg-none me-2"
        @click="isDrawerOpen = !isDrawerOpen"
      />
      <v-spacer />
      <theme-switcher />

      <!-- ✅ Notification Menu -->
      <v-menu
        v-model="isNotificationMenuOpen"
        offset-y
        :close-on-content-click="false"
      >
      <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on">
            <v-badge
              :content="parentAlerts.length"
              :value="parentAlerts.length > 0"
              overlap
              bordered
              class="custom-red-badge"
            >
              <v-icon >mdi-bell</v-icon>
            </v-badge>
          </v-btn>
        </template>

        <v-list>
          <v-list-item
            v-for="(notification, index) in parentAlerts"
            :key="index"
          >
            <v-list-item-content>
              <v-list-item-title>
  <!-- {{ notification.parent_name }} is arriving for {{ notification.student_name }} -->
    {{notification.message}}
</v-list-item-title>
<v-list-item-subtitle>
  {{ formatDate(notification.updated_at) }}
</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-list-item v-if="parentAlerts.length === 0">
            <v-list-item-content>
              <v-list-item-title>No notifications</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>

      <app-bar-user-menu
        :admin-name="teacherProfile.name"
        :admin-avatar="teacherProfile.avatar"
        profile-url="/grades/view/class_teacher"
        :admin="'Grade'"
      />
    </div>
  </div>
</v-app-bar>


    <!-- Main Content -->
    <v-main>
      <div class="app-content-container boxed-container pa-6">
        <slot></slot>
      </div>
    </v-main>
  </v-app>
</template>

<script>
import axios from 'axios';
import GradeVerticalNavMenu from './components/vertical-nav-menu/GradeVerticalNavMenu.vue';
import ThemeSwitcher from './components/ThemeSwitcher.vue';
import AppBarUserMenu from './components/AppBarUserMenu.vue';

export default {
  name: 'GradePanelLayout',
  components: {
    GradeVerticalNavMenu,
    ThemeSwitcher,
    AppBarUserMenu,
  },
  data() {
    return {
      isDrawerOpen: true,
      isNotificationMenuOpen: false,
      teacherProfile: {
        name: '',
        avatar: '',
      },
      parentAlerts: [],
    };
  },
  methods: {
    async fetchProfile() {
      try {
        const response = await axios.get('/grade-dashboard/panelprofile', {
          params: { user_id: localStorage.getItem('user_id') }
        });

        if (response.data.status) {
          this.teacherProfile = {
            name: response.data.data.user.name,
            avatar: response.data.data.user.avatar || '',
          };
        } else {
          console.error('Failed to fetch profile data');
        }
      } catch (error) {
        console.error('Error fetching profile:', error);
      }
    },

    async fetchAlertsFromBackend() {
      try {
        const teacherId = localStorage.getItem('user_id');
        const response = await axios(`/location/getNotificationsForTeacher?user_id=${teacherId}`);
        this.parentAlerts = response.data.data || [];
      } catch (error) {
        console.error('Failed to fetch alerts:', error);
      }
    },

    playSound() {
      const audio = new Audio(require('@/assets/notification.mp3'));
      audio.play().catch(err => {
        console.warn('Autoplay prevented or error:', err);
      });
    },

    listenToParentArriving() {
      const teacherId = localStorage.getItem('user_id');

      window.Echo.channel(`teacher.${teacherId}`)
        .listen('.ParentArriving', (event) => {
          if (event.teacher_id !== parseInt(teacherId)) return;

          // Remove existing alert for the same student
          this.parentAlerts = this.parentAlerts.filter(
            alert => alert.student_id !== event.student_id
          );

          const newAlert = {
            student_id: event.student_id,
            student_name: event.student_name,
            parent_name: event.parent_name,
            latitude: event.latitude,
            longitude: event.longitude,
            message:event.message,
          };

          this.parentAlerts.push(newAlert);
          this.playSound();

          this.$notify({
            title: `Parent Arriving`,
            text: `${event.parent_name} (for ${event.student_name}) is near the school.`,
            type: 'info'
          });
        })
        .error(error => {
          console.error('Error subscribing to channel:', error);
        });
    },

    listenToDismissalAnnouncements() {
  const gradeId = localStorage.getItem('grade_id');
  console.log("ss");
  if (!gradeId) {
    console.error('No grade ID found in localStorage.');
    return;
  }

  window.Echo.channel(`grade-panel.${gradeId}`)
    .listen('.ParentArrivalAnnounced', (event) => {
      this.$notify({
        title: 'Dismissal Alert',
        text: event.message || 'A new parent dismissal has been announced.',
        type: 'success',
        duration: 6000,
      });

      // Optional: Update alerts UI or store event
      this.parentAlerts.push({
        student_id: event.student_id,
        student_name: event.student_name,
        message: event.message,
        updated_at: new Date().toISOString(),
      });

      this.playSound();
    })
    .error(error => {
      console.error('Error subscribing to grade-panel channel:', error);
    });
},

    formatDate(dateString) {
    const options = {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    };
    return new Date(dateString).toLocaleString(undefined, options);
  },
  },
  created() {
    this.fetchProfile();
    this.fetchAlertsFromBackend();
    this.listenToParentArriving();
    console.log("Calling listenToDismissalAnnouncements()");
    this.listenToDismissalAnnouncements(); // 👈 Add this
  },
};
</script>

<style scoped>
.boxed-container {
  max-width: 1440px;
  margin: 0 auto;
}
.app-content-container {
  padding-top: 80px;
}

.custom-red-badge .v-badge__badge {
  background-color: red !important;
  color: white !important;
}

.v-badge__badge {
  font-size: 12px; /* Adjust size if needed */
}
</style>
